import React from "react";

// Components
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IonRow } from "@ionic/react";
import { withTranslation } from "react-i18next";
import MembersTableFiltersGroup from "./MembersTableFiltersGroup";

class MembersTableFilters extends React.Component<any, any> {
  render() {
    const { registrationStages, t } = this.props;
    const filterGroups = [
      {
        colSizeSm: "12",
        colSizeLg: "12",
        title: "Status",
        filters: [
          // { text: `1 / ${t("application")}`, key: "registration_stage_id", value: "1" },
          // { text: `1 / ${t("application")}`, key: "registration_stage_id", value: "2" },
          // { text: `2 / ${t("legal")}`, key: "registration_stage_id", value: "3" },
          // { text: `2 / ${t("legal")}`, key: "registration_stage_id", value: "4" },
          // { text: `3 / ${t("memberDetails")}`, key: "registration_stage_id", value: "5" },
          // { text: `3 / ${t("yourDetails")}`, key: "registration_stage_id", value: "6" },
          // { text: `3 / ${t("sponsorDetails")}`, key: "registration_stage_id", value: "7" },
          // { text: `3 / ${t("funFacts")}`, key: "registration_stage_id", value: "8" },
          // { text: `3 / ${t("moreAboutYou")}`, key: "registration_stage_id", value: "9" },
          // { text: `3 / ${t("bankDetails")}`, key: "registration_stage_id", value: "10" },
          // { text: t("pending"), key: "status", value: "pending" },
          { text: t("active"), key: "status", value: "active" },
          { text: t("declined"), key: "status", value: "declined" },
          { text: t("blocked"), key: "status", value: "blocked" },
          // { text: t("cancelled"), key: "status", value: "cancelled" },
        ],
      },
      // {
      //   colSizeSm: "12",
      //   colSizeLg: "3",
      //   title: t("category"),
      //   filters: [
      //     { text: t("male"), key: "race_category", value: "m" },
      //     { text: t("female"), key: "race_category", value: "f" },
      //   ],
      // },
      // {
      //   colSizeSm: "12",
      //   colSizeLg: "3",
      //   title: `${t("inRankings")}?`,
      //   filters: [
      //     { text: t("yes"), key: "in_rankings", value: "1" },
      //     { text: t("no"), key: "in_rankings", value: "0" },
      //   ],
      // },
      // {
      //   colSizeSm: "12",
      //   colSizeLg: "3",
      //   title: t("pendingRevisions"),
      //   filters: [
      //   { text: t("yes"), key: "pending_revisions", value: "1" },
      //   { text: t("no"), key: "pending_revisions", value: "0" },
      // ],
      // },
    ];

    return (
      this.props.showFilters &&
      registrationStages.length && (
        <div className={"members-table-filters wrapper"}>
          <div className={"members-table-filters__wrapper"}>
            <FontAwesomeIcon className="members-table-filters__close" icon={["far", "circle-xmark"]} onClick={this.props.toggleShowFilters} />
            <p className={"members-table-filters__title"}>Filters</p>
            <IonRow>
              {filterGroups.map((group: any, key: number) => (
                <MembersTableFiltersGroup key={key} group={group} handleClick={this.props.handleClick} activeFilters={this.props.activeFilters} />
              ))}
            </IonRow>
          </div>
        </div>
      )
    );
  }
}

export default withTranslation()(MembersTableFilters);
